export default "__VITE_ASSET__DL8ury6H__"